import api from '../api/api';

const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  if (response.data.data.token) {
    localStorage.setItem('token', response.data.data.token); 
    localStorage.setItem('user', JSON.stringify(response.data.data));
  }
  return response.data.data;
};

const register = async (fullName, email, password) => {
  const response = await api.post('/auth/register', { fullName, email, password });
  if (response.data.data.token) {
    localStorage.setItem('token', response.data.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.data));
  }
  return response.data.data;
};

const logout = () => {
  clearStorage();
};

const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

const getToken = () => {
  return localStorage.getItem('token');
};

// Clear all auth-related data from localStorage
const clearStorage = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  // Add any other auth-related keys you might be storing
};

const authService = {
  login,
  register,
  logout,
  getCurrentUser,
  getToken,
  clearStorage, // Export for use in AuthContext
};

export default authService;